import React from 'react';
import Input from '../Input';

const PersonalDataStep = ({ formData, updateFormData, errors }) => {
  return (
    <div>
      <h2 className="text-3xl font-semibold text-gray-900 mb-6">
        Dados Pessoais
      </h2>
      
      <div className="space-y-4">
        <Input
          label="Nome Completo"
          value={formData.nome}
          onChange={(e) => updateFormData('nome', e.target.value)}
          placeholder="Digite seu nome completo"
          required
          error={errors.nome}
        />

        <div>
          <Input
            label="Telefone"
            type="tel"
            value={formData.telefone}
            onChange={(e) => updateFormData('telefone', e.target.value)}
            placeholder="(11) 99999-9999"
            required
            error={errors.telefone}
            mask="phone"
          />
                  <p className="text-base text-gray-500 -mt-2 mb-4">
                    Digite o DDD + número (ex: 11999999999)
                  </p>
        </div>

        <Input
          label="E-mail"
          type="email"
          value={formData.email}
          onChange={(e) => updateFormData('email', e.target.value)}
          placeholder="seu@email.com"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label="Cidade"
            value={formData.cidade}
            onChange={(e) => updateFormData('cidade', e.target.value)}
            placeholder="São Paulo"
            required
            error={errors.cidade}
          />

          <Input
            label="Estado"
            value={formData.estado}
            onChange={(e) => updateFormData('estado', e.target.value)}
            placeholder="SP"
            required
            error={errors.estado}
          />

          <Input
            label="Bairro"
            value={formData.bairro}
            onChange={(e) => updateFormData('bairro', e.target.value)}
            placeholder="Centro"
            required
            error={errors.bairro}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDataStep;
